export const EXPANDING_BUTTON__CONTAINER_CLASS = 'expanding_button__container';
export const EXPANDING_BUTTON__BUTTON_CLASS = 'expanding_button__button';
